import React, { FC } from 'react'

import { IconType } from '../../common/types'

const NucFile: FC<IconType> = ({ iconColor = 'currentColor', ...svgProps }) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 14 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
    >
      <path
        d='M0.25 2.5C0.25 1.26953 1.23438 0.25 2.5 0.25H8.125V4.75C8.125 5.38281 8.61719 5.875 9.25 5.875H13.75V16C13.75 17.2656 12.7305 18.25 11.5 18.25H2.5C1.23438 18.25 0.25 17.2656 0.25 16V2.5ZM9.25 4.75V0.25L13.75 4.75H9.25Z'
        fill={iconColor}
      />
    </svg>
  )
}

export default NucFile
